import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="input-sync"
export default class extends Controller {
	static targets = ["input"]

	sync({ currentTarget }) {
		this.inputTargets.forEach((input) => {
			// Den Input Value nur übertagen, wenn im Ziel Input Feld 0 steht
			const inputNumber = currencyStringToFloat(input.value)

			if (inputNumber == 0) input.value = currentTarget.value
		})
	}
}
